import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import Preloader from "../helper/Preloader";
import ScrollToTop from "react-scroll-to-top";
import useHomeStore from "../components/ZustandStore/useHomeStore";

const Base = () => {
  const location = useLocation();

  // Manage preloader visibility state
  const [isLoading, setIsLoading] = useState(true);

  // Zustand store hooks
  const { links, categories, fetchMenu } = useHomeStore();

  useEffect(() => {
    fetchMenu(); // Fetch data using Zustand
  }, [fetchMenu]);

  useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className="base-layout">
      <main className="content">
        <HeaderOne apiLinks={links} apiCategories={categories} />
        {isLoading && <Preloader />}
        <Outlet />
        <FooterOne />
      </main>
      <ScrollToTop />
    </div>
  );
};

export default Base;
